import React, {Component } from "react";

class Scroll extends Component {
    state={};
    render() {
        return <div className="scrolled" id="scrolls"/>
    }
}

export default Scroll;